<template>
    <div
        tabindex="0"
        @keyup.escape="$root.focusStep()"
    >
        <div
            v-for="option in options"
            :key="option.value"
            class="my-2 mr-2"
        >
            <input
                :id="'checkbox_' + option.value + '_' + option.label"
                :checked="value.includes(option.value)"
                :value="option.value"
                type="checkbox"
                @change="onChange($event)"
            >
            <base-label :for="'checkbox_' + option.value + '_' + option.label">{{ option.label }}</base-label>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseInputCheckbox',
  props: {
    options: {
      type: Array,
      required: true
    },

    value: Array
  },

  emits: ['input'],
  data () {
    return {
      name: Math.random()
    }
  },

  methods: {
    onChange (e) {
      const arr = this.value
      e.target.checked ? arr.push(e.target.value) : arr.splice(arr.indexOf(e.target.value), 1)

      this.$emit('input', arr)
    }
  }
}
</script>

<style scoped>

</style>
